<template>
  <header class="site-header-modern">
    <div class="header-inner">
      <div class="header-logo">
        <a :href="homepage">
          <img :src="logo" alt="logo">
        </a>
      </div>
      <nav class="header-nav">
        <ul class="nav-list">
          <li v-for="(item, index) in links" :key="index" class="nav-item">
            <router-link :to="item.link" exact-active-class="active">{{ item.name }}</router-link>
          </li>
        </ul>
      </nav>
      <div class="header-actions">
        <div class="lang-change" @click="changeLanguage">
          <span :class="{active: lang === 'zh'}">中文</span>
          <span class="lang-divider">/</span>
          <span :class="{active: lang === 'en'}">EN</span>
        </div>
        <button class="search-btn" @click="toggleSearch">
          <span class="search-icon"></span>
        </button>
        <button
          class="mobile-menu-btn"
          :class="{open: isMobileMenuOpen}"
          @click="toggleMobileMenu"
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- Mobile Menu -->
    <transition name="slide">
      <div
        v-show="isMobileMenuOpen"
        class="mobile-menu"
        ref="mobileMenu"
      >
        <ul class="mobile-nav-list">
          <li
            v-for="(item, index) in links"
            :key="index"
            class="mobile-nav-item"
          >
            <router-link
              :to="item.link"
              exact-active-class="active"
              @click.native="closeMobileMenu"
            >{{ item.name }}</router-link>
          </li>
        </ul>
        <div class="mobile-lang-change" @click="changeLanguage">
          <span :class="{active: lang === 'zh'}">中文</span>
          <span class="lang-divider">/</span>
          <span :class="{active: lang === 'en'}">EN</span>
        </div>
      </div>
    </transition>

    <!-- Overlay -->
    <transition name="fade">
      <div
        v-show="isMobileMenuOpen"
        class="mobile-overlay"
        @click="closeMobileMenu"
      ></div>
    </transition>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isMobileMenuOpen: false
    };
  },
  computed: {
    homepage() {
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        document.title = '美乐创';
        return 'http://www.mltcloud.com/';
      }
      return 'http://www.cashzp.com/';
    },
    lang() {
      let srcLan = this.$i18n.locale;
      if (srcLan.indexOf('en') !== -1) {
        return 'en';
      }
      return 'zh';
    },
    logo() {
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        return require(`@/assets/images/mllogo.png`);
      }
      return require(`@/assets/images/logo-1-${this.lang}.png`);
    },
    links() {
      return [
        { name: this.$t("nav.home"), link: "/" },
        { name: this.$t("nav.products"), link: "/products" },
        { name: this.$t("nav.leecho"), link: "/leecho" },
        { name: this.$t("nav.contact"), link: "/contact" },
        { name: this.$t("nav.about"), link: "/about" },
        { name: this.$t("nav.download"), link: "/download" }
      ];
    }
  },
  methods: {
    changeLanguage() {
      let srcLan = this.lang;
      if (srcLan.indexOf('en') !== -1) {
        srcLan = 'zh';
      } else {
        srcLan = 'en';
      }
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        srcLan += '_ml';
      }
      this.$i18n.locale = srcLan;
      this.$forceUpdate();
    },
    toggleSearch() {
      // placeholder for search functionality
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    handleOutsideClick(e) {
      const header = this.$el;
      if (header && !header.contains(e.target)) {
        this.closeMobileMenu();
      }
    }
  },
  watch: {
    isMobileMenuOpen(val) {
      if (val) {
        document.addEventListener('click', this.handleOutsideClick);
        document.body.style.overflow = 'hidden';
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
        document.body.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.body.style.overflow = '';
  }
};
</script>

<style lang="stylus" scoped>
.site-header-modern {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}

.header-logo {
  a {
    display: block;
  }
  img {
    height: 50px;
    width: auto;
    display: block;
  }
}

.header-nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 36px;
}

.nav-item {
  a {
    text-decoration: none;
    color: #333;
    font-size: 15px;
    font-weight: 500;
    padding: 8px 0;
    position: relative;
    transition: color 0.3s ease;
    display: inline-block;

    &:hover {
      color: #0066cc;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background-color: #0066cc;
      transition: width 0.3s ease;
    }

    &:hover::after,
    &.active::after {
      width: 100%;
    }

    &.active {
      color: #0066cc;
    }
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.lang-change {
  font-size: 13px;
  color: #666;
  cursor: pointer;
  user-select: none;

  span {
    transition: color 0.3s ease;

    &.active {
      color: #0066cc;
      font-weight: 600;
    }
  }

  .lang-divider {
    margin: 0 4px;
    color: #ccc;
  }
}

.search-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0066cc;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  padding: 0;

  &:hover {
    background: #0052a3;
  }

  .search-icon {
    display: block;
    width: 14px;
    height: 14px;
    border: 2px solid #fff;
    border-radius: 50%;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 7px;
      height: 2px;
      background: #fff;
      bottom: -1px;
      right: -5px;
      transform: rotate(45deg);
      transform-origin: left center;
    }
  }
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  width: 40px;
  height: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  z-index: 1002;

  span {
    display: block;
    width: 24px;
    height: 2px;
    background: #333;
    transition: all 0.3s ease;
    border-radius: 1px;
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1001;
  overflow-y: auto;
  padding: 20px 24px 40px;
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-item {
  a {
    display: block;
    padding: 16px 0;
    color: #333;
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #f0f0f0;
    transition: color 0.3s ease;

    &:hover,
    &.active {
      color: #0066cc;
    }
  }

  &:last-child a {
    border-bottom: none;
  }
}

.mobile-lang-change {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  text-align: center;

  span.active {
    color: #0066cc;
    font-weight: 600;
  }

  .lang-divider {
    margin: 0 8px;
    color: #ccc;
  }
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .header-nav,
  .header-actions .lang-change,
  .search-btn {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-menu,
  .mobile-overlay {
    display: block;
  }

  .header-logo img {
    height: 40px;
  }

  .header-inner {
    height: 60px;
  }
}

@media (max-width: 480px) {
  .header-inner {
    padding: 0 16px;
  }

  .header-logo img {
    height: 36px;
  }
}
</style>
